module.exports = __webpack_public_path__ + "static/media/packingCheck.d59a9362.png";